import { load3DLogo } from '../../vendor/index.js';

export default {
  init() {
    /* Script pour le module vidéo avec curseur, preview et ligne élastique */
    $(
      '.module-popup-calculateur-prix .gform-body .first_template .gform_page_fields .gform_fields .evenement .ginput_container.ginput_container_radio .gfield_radio .gchoice.image-choices-choice .image-choices-choice-image-wrap img, .module-popup-calculateur-prix .gform-body .gform_page_fields .gform_fields .image-choices-field .ginput_container.ginput_container_radio .gfield_radio .gchoice.image-choices-choice .image-choices-choice-image-wrap img'
    ).each(function () {
      import_url_image = $(this).attr('src');
      $(this)
        .parent()
        .css('mask-image', 'url(' + import_url_image + ')');
      $(this)
        .parent()
        .css('background-image', 'none');
    });


    //init 3D logo
    let scene3D;
    var import_url_image;

    MutationObserver =
      window.MutationObserver || window.WebKitMutationObserver;
    var observer = new MutationObserver(function (mutations, observer) {

      $(
        '.module-popup-calculateur-prix .gform-body .first_template .gform_page_fields .gform_fields .evenement .ginput_container.ginput_container_radio .gfield_radio .gchoice.image-choices-choice .image-choices-choice-image-wrap img, .module-popup-calculateur-prix .gform-body .gform_page_fields .gform_fields .image-choices-field .ginput_container.ginput_container_radio .gfield_radio .gchoice.image-choices-choice .image-choices-choice-image-wrap img'
      ).each(function () {
        import_url_image = $(this).attr('src');
        $(this)
          .parent()
          .css('mask-image', 'url(' + import_url_image + ')');
        $(this)
          .parent()
          .css('background-image', 'none');
      });

    });

    observer.observe(document.getElementsByClassName('popup_calculateur')[0], {
      subtree: true,
      attributes: true,
    });


    function openPopup() {
      const logoContainer = $('.wrap_popup .logo_3d_calculateur');

      load3DLogo({ container: logoContainer[0], dark: true }).then((scene) => {
        scene3D = scene;
        scene3D.play();
      });

      $('.popup_calculateur').addClass('open');
      $('html').addClass('popup');
      $('.module-popup-calculateur-prix').css({ pointerEvents: 'auto' });
      if ($('.module-popup-calculateur-prix .popup_calculateur .popup_content').find('.gform_confirmation_wrapper').length !== 0) {
        $('.module-popup-contact .popup_calculateur .wrap_popup .logo_3d').css('display', 'block');
      }
      if (scene3D && window.matchMedia('(min-width: 1100px)').matches) {
        scene3D.play();
      }
    }

    $('.iconpopup').on('click', openPopup);

    $('.popup_calculateur .close').on('click', function () {
      const formId = document.querySelector('.popup_content').getAttribute('data-formId')

      $('.popup_calculateur').removeClass('open');
      $('html').removeClass('popup');
      $('.module-popup-calculateur-prix').css({ pointerEvents: 'none' });

      if (scene3D) {
        scene3D.pause();
      }
    });

    jQuery(document).on('gform_page_loaded', function (event, form_id, current_page) {
      if (current_page == '6') {
        $('.popup_calculateur .gform_body .gform_page .gform_page_fields .gform_fields .gfield_visibility_visible.dates .ginput_container_list .gfield_list_container .gfield_list_groups .gfield_list_group .gfield_list_group_item input').addClass('large');

        var title_to_dates = ["12/12/2023", "11h30", "11h30"];
        var text_to_placeholder = [];
        $('.popup_calculateur .gform_body .gform_page .gform_page_fields .gform_fields .gfield_visibility_visible.dates .ginput_container_list .gfield_list_container .gfield_list_header .gfield_header_item').each(function (index) {
          text_to_placeholder.push($(this).text());
          $('.popup_calculateur .gform_body .gform_page .gform_page_fields .gform_fields .gfield_visibility_visible.dates .ginput_container_list .gfield_list_container .gfield_list_groups .gfield_list_group').each(function (indexIn) {
            $(this).find('.gfield_list_group_item').eq(indexIn).find('input').attr('placeholder', title_to_dates[index]);
            $(this).find('.gfield_list_group_item').eq(index).find('input').after('<div class="focus-border"></div>');
            $(this).find('.gfield_list_group_item').eq(index).find('.focus-border').after('<label class="label">' + title_to_dates[index] + '</label>');
          });
        });




        $(
          '.popup_calculateur .gform_body .gform_page .gform_page_fields .gform_fields .gfield_visibility_visible.dates .ginput_container_list .gfield_list_container .gfield_list_groups .gfield_list_group .gfield_list_group_item input'
        ).each(function () {
          $(this).focusout(function () {
            if ($(this).val() != '') {
              $(this).addClass('has-content');
            } else {
              $(this).removeClass('has-content');
              $(this).val('');
            }
          });
        });

        $(
          '.popup_calculateur .gform_body .gform_page .gform_page_fields .gform_fields .gfield_visibility_visible.dates .ginput_container_list .gfield_list_container .gfield_list_groups .gfield_list_group .gfield_list_group_item input'
        ).each(function () {
          if ($(this).val() != '') {
            $(this).addClass('has-content');
          } else {
            $(this).removeClass('has-content');
            $(this).val('');
          }
        });
      }

      $(
        '.popup_calculateur .gform_body .gform_page .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_text, .popup_calculateur .gform_body .gform_page .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_phone, .popup_calculateur .gform_body .gform_page .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_email, .popup_calculateur .gform_body .gform_page .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container .name_first, .popup_calculateur .gform_body .gform_page .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container .name_last'
      ).each(function () {
        $(this).append('<span class="focus-border"></span>');
      });

      $(
        '.popup_calculateur .gform_body .gform_page .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_text input, .popup_calculateur .gform_body .gform_page .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_textarea textarea, .popup_calculateur .gform_body .gform_page .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_phone input, .popup_calculateur .gform_body .gform_page .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_email input, .popup_calculateur .gform_body .gform_page .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container .name_first input, .popup_calculateur .gform_body .gform_page .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container .name_last input'
      ).each(function () {
        $(this).focusout(function () {
          if ($(this).val() != '') {
            $(this).addClass('has-content');
          } else {
            $(this).removeClass('has-content');
            $(this).val('');
          }
        });
      });

      $(
        '.popup_calculateur .gform_body .gform_page .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_text input, .popup_calculateur .gform_body .gform_page .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_textarea textarea, .popup_calculateur .gform_body .gform_page .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_phone input, .popup_calculateur .gform_body .gform_page .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_email input, .popup_calculateur .gform_body .gform_page .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container .name_first input, .popup_calculateur .gform_body .gform_page .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container .name_last input'
      ).each(function () {
        if ($(this).val() != '') {
          $(this).addClass('has-content');
        } else {
          $(this).removeClass('has-content');
          $(this).val('');
        }
      });

      $(
        '.popup_calculateur .gform_body .gform_page .gform_page_fields .gform_fields .gfield_visibility_visible label.gfield_label'
      ).each(function () {
        $(this).next().append($(this));
      });

      $('.popup_calculateur .gform_body .gform_page .gform_page_fields .gform_fields .textarea_project.gfield_visibility_visible .ginput_container_textarea').append(function () {
        var label_inside = $('.popup_calculateur .gform_body .gform_page .gform_page_fields .gform_fields .textarea_project.gfield_visibility_visible label.gfield_label');
        return label_inside;
      });


    });
  },
};
